var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-modal", {
    attrs: {
      "modal-title": _vm.$t("pages.profile.tabs.personal_data.general"),
      "show-spinner": _vm.isLoading,
      "show-modal": _vm.showModal,
      modalLarge: true,
      "loading-primary-footer-button": _vm.isLoading,
      showSecondaryFooterButton: false,
    },
    on: _vm._d({}, [
      _vm.primaryEvent,
      _vm.onPrimaryButtonClicked,
      _vm.closeEvent,
      _vm.onCloseButtonClicked,
    ]),
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "profile" }, [
              _c("article", [
                _c("form", [
                  _vm.error
                    ? _c(
                        "div",
                        {
                          staticClass: "alert alert-danger",
                          attrs: { role: "alert" },
                        },
                        [_vm._v(" " + _vm._s(_vm.error) + " ")]
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _vm.canEditName
                          ? _c("employee-name-field", {
                              attrs: {
                                id: "edit-employee-name",
                                name: "name",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                        _vm.canEditFirstName
                          ? _c("employee-first-family-name-field", {
                              attrs: {
                                id: "edit-employee-first-family-name",
                                name: "firstFamilyName",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                        _vm.canEditSecondName
                          ? _c("employee-second-family-name-field", {
                              attrs: {
                                id: "edit-employee-second-family-name",
                                name: "secondFamilyName",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _vm.canEditEmployeeCompanyPhone
                          ? _c("employee-phone-no-2-field", {
                              attrs: {
                                id: "edit-employee-phone-no-2",
                                name: "phoneNo2",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                        _vm.canEditEmail
                          ? _c("employee-company-email-field", {
                              attrs: {
                                id: "edit-employee-company-email",
                                name: "companyEmail",
                                form: _vm.form,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }